import { styled } from '@uhg-abyss/web/tools/styled';

import { notMobile } from '../../../common/ConstantsStyles';

export const LocationInputContainer = styled('div', {
  display: 'flex',
  top: '0',
  zIndex: 1,
});

export const LocationInputRow = styled('div', {
  display: 'flex',
  flexDirection: 'row',
  top: '6px',
  width: '100%',
});

export const LocationSearchPieceContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  [`@media ${notMobile}`]: {
    gap: '4px',
  },
});

export const LocationSearchLabel = styled('label', {
  dynamic: ({ cssProps: { isGEHAV2 } = {} }) => ({
    color: isGEHAV2 ? '$core.color.brand.100' : '$core.color.neutral.80',
  }),
  fontSize: '14px',
  fontWeight: 700,
  lineHeight: '18px',
});

export const LocationInputCloseButtonStyle = {
  'abyss-layout-group': {
    height: '32px',
    marginTop: '20px',
    marginRight: '2px',
  },
};
